/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBarRight = createReactComponent("outline", "arrow-bar-right", "IconArrowBarRight", [["path", { "d": "M20 12l-10 0", "key": "svg-0" }], ["path", { "d": "M20 12l-4 4", "key": "svg-1" }], ["path", { "d": "M20 12l-4 -4", "key": "svg-2" }], ["path", { "d": "M4 4l0 16", "key": "svg-3" }]]);

export { IconArrowBarRight as default };
//# sourceMappingURL=IconArrowBarRight.mjs.map
